import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=b84fe006"
import script from "./answer.vue?vue&type=script&lang=js"
export * from "./answer.vue?vue&type=script&lang=js"
import style0 from "./answer.vue?vue&type=style&index=0&id=b84fe006&prod&lang=scss"
import style1 from "./answer.vue?vue&type=style&index=1&id=b84fe006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports